"use client";

import { i18n } from "@/i18n/i18n.config";
import { useLocale } from "@/libs/base/components/locale-provider";
import Link from "next/link";
import { forwardRef } from "react";

interface ComponentProps {
  children: React.ReactNode;
  href: string;

  // [key: string]: any;
}

type LinkProps = Parameters<typeof Link>[0];
const TranslatedLink = forwardRef<HTMLAnchorElement, LinkProps & ComponentProps>(({ href, ...props }, ref) => {
  const locale = useLocale();

  // Never prefix twice: CMS hrefs may already carry a locale (e.g. `/de/faq`).
  const firstSegment = href.split("/")[1] ?? "";
  const hasLocalePrefix = (i18n.locales as readonly string[]).includes(firstSegment);
  const path = href.startsWith("/") && !hasLocalePrefix ? `/${locale}${href}` : href;

  return <Link ref={ref} href={path} {...props} />;
});

export default TranslatedLink;
